import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../../../services/api'
import { usePageHeader } from '../../../contexts/PageHeaderContext'
import { ReportErrorState, ReportLoadingState, reportTitle } from './IncomeReportComponents'
import NdflReportPanel from './NdflReportPanel'
import LegacyIncomeReportAccountantPage from './LegacyIncomeReportAccountantPage'
import './Reports.css'

export default function IncomeReportAccountantPage() {
  const { id } = useParams()
  const [data, setData] = useState(null)
  const [error, setError] = useState('')
  const [attempt, setAttempt] = useState(0)
  const [legacyOpen, setLegacyOpen] = useState(false)
  const report = data?.report
  usePageHeader({
    title: report ? `Бухгалтерский отчет: ${reportTitle(report)}` : 'Бухгалтерский отчет',
    backLink: `/company/reports/${id}`,
    backLabel: '← К отчету',
  }, [id, report?.id, report?.title])

  useEffect(() => {
    let active = true
    setData(null); setError(''); setLegacyOpen(false)
    api.get(`/company/reports/${id}/ndfl`).then(({ data: result }) => {
      if (active) setData(result)
    }).catch((err) => {
      if (active) setError(err.response?.data?.error || 'Не удалось загрузить отчёт')
    })
    return () => { active = false }
  }, [id, attempt])

  if (error) return <ReportErrorState message={error} onRetry={() => setAttempt((value) => value + 1)} />
  if (!data) return <ReportLoadingState message="Загрузка бухгалтерского отчёта…" />
  if (data.legacy) return <LegacyIncomeReportAccountantPage key={id} />
  return <>
    <div className="no-print"><NdflReportPanel key={id} id={id} initialData={data} /></div>
    <details className="ndfl-legacy" onToggle={(event) => setLegacyOpen(event.currentTarget.open)}>
      <summary className="no-print">Прежняя форма без НДФЛ · CSV / PDF</summary>
      {legacyOpen && <LegacyIncomeReportAccountantPage key={id} />}
    </details>
  </>
}
